import { TextField, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

const STATUS_OPTIONS = [
	{ label: 'All Statuses', value: 'all' },
	{ label: 'Starting', value: 'starting' },
	{ label: 'Ingesting', value: 'ingesting' },
	{ label: 'Ingested', value: 'ingested' },
	{ label: 'Ingestion Failed', value: 'ingestion_failed' },
	{ label: 'Syncing', value: 'syncing' },
	{ label: 'Synced', value: 'synced' },
	{ label: 'Sync Failed', value: 'sync_failed' },
];

const StatusDropdown = ({ value, onChange }) => {
	// Convert empty string from URL to 'all' for UI display
	const displayValue = value === '' ? 'all' : value;

	const handleChange = (e) => {
		// Convert 'all' back to empty string for backend
		const newValue = e.target.value === 'all' ? '' : e.target.value;
		onChange({ target: { value: newValue } });
	};

	return (
		<TextField
			data-testid='status-dropdown'
			select
			value={displayValue}
			onChange={handleChange}
			size='small'
			SelectProps={{
				renderValue: (selectedValue) => {
					const option = STATUS_OPTIONS.find(
						(opt) => opt.value === selectedValue
					);
					return option?.label || 'All Statuses';
				},
			}}
			sx={{
				width: '150px',
			}}
		>
			{STATUS_OPTIONS.map((option) => (
				<MenuItem key={option.value} value={option.value}>
					{option.label}
				</MenuItem>
			))}
		</TextField>
	);
};

StatusDropdown.propTypes = {
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default StatusDropdown;
